import { getType } from 'typesafe-actions'

import { setFile } from '../actions/file'
import { ActionTypes } from '../actions/types'

const initialState = null

export type FileState = File | null

export default (state: FileState = initialState, action: ActionTypes) => {
  switch (action.type) {
    case getType(setFile):
      return action.payload
    default:
      return state
  }
}
